// Iter XX.26 — persistent browser identity.
//
// One stable ID per browser profile, stored in localStorage. Shared
// across all tabs on askgully.com, survives browser restarts, never
// touched by sessionStorage. Included on every /web/session,
// /web/session/persist, /web/chat, and /web/sessions/claim call so the
// backend can attach anonymous conversations to the same authenticated
// user once the player signs in on any tab.
const STORAGE_KEY = "gully_browser_id";

function _generate() {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
  } catch { /* fall through */ }
  // Fallback (older browsers / privacy modes). 128 bits of entropy from
  // Math.random is weak but sufficient for a browser-scoped correlator.
  const rnd = () => Math.floor(Math.random() * 0xffffffff).toString(16).padStart(8, "0");
  return `${rnd()}-${rnd()}-${rnd()}-${rnd()}`;
}

export function getBrowserId() {
  try {
    let bid = localStorage.getItem(STORAGE_KEY);
    if (bid && bid.length >= 8) return bid;
    bid = _generate();
    localStorage.setItem(STORAGE_KEY, bid);
    return bid;
  } catch {
    // localStorage disabled (private mode). Return a per-tab id so the
    // request still carries a browser_id header; the server treats it
    // as non-authoritative in that case.
    return _generate();
  }
}
